import { makeAutoObservable } from 'mobx';

import { Socket } from '@/lib/api/Socket';

/**
 * @implements {EN.Market}
 */
export class Market {
  /**
   * A property to track markets that are waiting for deletion.
   * We delaying market deletions to reduce layout shifts when markets updating to frequently
   *
   * @type {NodeJS.Timeout | null}
   */
  deletionTimeOut = null;

  /**
   * @param {EN.Market} model
   */
  constructor(model) {
    makeAutoObservable(this);

    /** @type {EN.Market['id']} */
    this.id = '';
    /** @type {EN.Market['identity']} */
    this.identity = '';
    /** @type {EN.Market['interval']} */
    this.interval = '';
    /** @type {EN.Market['kind']} */
    this.kind = 0;
    /** @type {EN.Market['lid']} */
    this.lid = '';
    /** @type {EN.Market['param']} */
    this.param = null;
    /** @type {EN.Market['pid']} */
    this.pid = '';
    /** @type {EN.Market['subInterval']} */
    this.subInterval = null;
    /** @type {EN.Market['isUnsubscribed']} */
    this.isUnsubscribed = false;
    /** @type {EN.Market['competitorId']} */
    this.competitorId = null;
    /** @type {EN.Market['sortIndex']} */
    this.sortIndex = -1;
    /** @type {EN.Market['tabSortIndex']} */
    this.tabSortIndex = {};

    Object.assign(this, model);
  }

  /** @type {EN.Market['name']} */
  name = '';

  /** @type {EN.Market['outcomes']} */
  outcomes = [];

  status = 0;

  update(data) {
    const childItems = Object.fromEntries(this.outcomes.map((item) => [item.lid, item]));
    let isMissingOutcome = false;

    data.outcomes = data.outcomes.map((outcome) => {
      const sourceItem = childItems[outcome.lid];

      if (sourceItem) {
        outcome = Object.assign(sourceItem, outcome);
      } else {
        isMissingOutcome = true;
      }

      return outcome;
    });

    Object.assign(this, data);
  }
}
